import tableHighlightedContentMultiSelectable from './tableHighlightedContentMultiSelectable';
// import tableContent from './tableRelatedAppContents';

export default {
  title: 'Contents',
  attributeName: 'appContent',
  getURL: 'externalContent/appId/canvas/',
  noArea:true,
  noTitle:true,
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableHighlightedContentMultiSelectable,
  autoUpdate: true,

};
